import { Card, Divider, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useTranslation } from '../../i18n/i18n';
import './TempPasswordDisplay.scss';

const { Text } = Typography;

interface TempPasswordDisplayProps {
  password: string;
}

const TempPasswordDisplay = ({ password }: TempPasswordDisplayProps) => {
  const { t } = useTranslation('users', { keyPrefix: 'modal' });

  return (
    <div className={'TempPasswordDisplay'}>
      <Card size={'small'} className={'TempPasswordCard'}>
        <div className={'TempPasswordCard__div'}>
          <WarningOutlined style={{ marginTop: '5px' }} />
          <div className={'TempPasswordCard__text'}>
            <Text className={'TempPasswordCard__warningTitle'}>{t('tempPasswordTitle')}</Text>
            <Text>{t('tempPasswordDesc')}</Text>
          </div>
        </div>
      </Card>
      <Card size={'small'}>
        <div>
          <Text>{t('tempPass')}</Text>
          <Divider className={'TempPasswordCard__divider'} />
          <Text className={'TempPasswordCard__password'}>{password}</Text>
        </div>
      </Card>
    </div>
  );
};

export default TempPasswordDisplay;
